import type React from 'react';
import { memo } from 'react';

import { Camera } from '@shared/assets';
import { AddressIcon } from '@shared/ui/smart-icons';

import { useSchedule } from '../../model';
import * as st from './styles.module.scss';

type Props = {
	id: number;
};

export const BusyIcon: React.FC<Props> = memo(({ id }) => {
	const { schedule } = useSchedule(id);

	const getAddressId = () => {
		if (!schedule || !schedule.address) return;

		if (typeof schedule.address === 'number') return schedule.address;

		if (!schedule.address.id) return;

		return schedule.address.id;
	};

	const icons: { [x: string]: JSX.Element } = {
		ON: <Camera />,
		OF: <AddressIcon id={getAddressId()} />,
	};

	return <div className={st.icon}>{icons[schedule?.type]}</div>;
});
